import {
  Datagrid,
  FunctionField,
  List,
  TextField,
  TextInput
} from "react-admin";
import useSetTabTitle from "hooks/useSetTabTitle";
import FilterTemplate from "components/FilterTemplate";
import React from "react";
import { Box, Stack } from "@mui/material";
import QuestionDocumentTypeActions from "resources/questionDocumentType/QuestionDocumentTypeActions";

const questionDocumentTypeFilter = [
  <TextInput label="Название" source="title" alwaysOn size={"small"} fullWidth/>
]

const QuestionDocumentTypeList = () => {
  useSetTabTitle("Типы документов вопросов");

  return (
    <List
      title="Типы документов вопросов"
      actions={<QuestionDocumentTypeActions/>}
    >
      <FilterTemplate filters={questionDocumentTypeFilter}/>
      <Datagrid bulkActionButtons={false}>
        <TextField source={"title"} label="Название типа" sortable={false}/>
        <FunctionField
          label="Цвет"
          render={(record) => {
            return (
              <Stack direction="row" spacing={1} alignItems="center">
                <Box sx={{ width: 16, height: 16, borderRadius: '50%', bgcolor: record.color }}/>
                <Box>{String(record.color).toUpperCase()}</Box>
              </Stack>
            );
          }}
        />
      </Datagrid>
    </List>
  )
};

export default QuestionDocumentTypeList